<template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- 1. ترويسة الصفحة -->
    <div class="d-flex justify-content-between align-items-center mb-4 bg-white p-3 rounded shadow-sm">
      <div>
        <h4 class="fw-bold text-primary mb-1">
          <i class="fas fa-paper-plane ms-2"></i> سجل التعليمات والتعاميم
        </h4>
        <p class="text-muted small mb-0">متابعة دقيقة لنسبة اطلاع رؤساء اللجان على التعليمات المرسلة</p>
      </div>
      <button @click="refresh" class="btn btn-outline-primary btn-sm rounded-pill px-3">
        <i class="fas fa-sync-alt ms-1"></i> تحديث البيانات
      </button>
    </div>

    <!-- 2. شبكة الكروت (بدلاً من الجدول الممل) -->
    <div class="row g-3">
      <div v-for="item in instructions.data" :key="item.id" class="col-md-6 col-lg-4">
        <div class="card border-0 shadow-sm h-100 instruction-card">
          
          <!-- شريط علوي ملون حسب النوع -->
          <div class="card-header border-0 d-flex justify-content-between align-items-center" 
               :class="item.type === 'urgent' ? 'bg-danger-subtle text-danger' : 'bg-primary-subtle text-primary'">
            <span class="badge rounded-pill" :class="item.type === 'urgent' ? 'bg-danger' : 'bg-primary'">
              {{ item.type === 'urgent' ? 'عاجل جداً' : 'تنبيه عام' }}
            </span>
            <small class="fw-bold opacity-75">{{ formatDate(item.created_at) }}</small>
          </div>

          <div class="card-body">
            <!-- العنوان والمحتوى المختصر -->
            <h5 class="fw-bold text-dark mb-2 text-truncate">{{ item.title }}</h5>
            <p class="text-muted small mb-3 text-truncate-2">{{ item.content }}</p>

            <!-- مؤشر القراءة -->
            <div class="progress-section mt-4">
              <div class="d-flex justify-content-between align-items-end mb-1">
                <span class="small fw-bold text-secondary">نسبة الاطلاع</span>
                <span class="small fw-bold" :class="getProgressTextColor(item.readers_count, item.total_target)">
                  {{ calculatePercent(item.readers_count, item.total_target) }}%
                </span>
              </div>
              <div class="progress rounded-pill" style="height: 8px;">
                <div 
                  class="progress-bar rounded-pill" 
                  :class="getProgressColor(item.readers_count, item.total_target)"
                  role="progressbar" 
                  :style="{ width: calculatePercent(item.readers_count, item.total_target) + '%' }"
                ></div>
              </div>
              <div class="d-flex justify-content-between mt-1">
                <small class="text-muted xx-small">قرأ: {{ item.readers_count }}</small>
                <small class="text-muted xx-small">المستهدف: {{ item.total_target }}</small>
              </div>
            </div>
          </div>

          <!-- زر التفاصيل -->
          <div class="card-footer bg-white border-0 pt-0 pb-3">
            <button @click="openDetails(item.id)" class="btn btn-light w-100 text-primary fw-bold btn-hover-effect">
              <i class="fas fa-eye ms-2"></i> عرض تقرير المتابعة
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- 3. نافذة التفاصيل (Modal المحسن) -->
    <div v-if="showModal" class="modal-backdrop fade show"></div>
    <div v-if="showModal" class="modal fade show d-block" tabindex="-1" @click.self="closeModal">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content border-0 shadow-lg">
          
          <div class="modal-header bg-light">
            <div>
              <h5 class="modal-title fw-bold text-dark">تقرير المتابعة التفصيلي</h5>
              <small class="text-muted">لعنوان: {{ selectedItem?.instruction.title }}</small>
            </div>
            <button type="button" class="btn-close" @click="closeModal"></button>
          </div>
          
          <div class="modal-body p-0 bg-white" v-if="selectedItem">
            
            <!-- التبويبات -->
            <ul class="nav nav-tabs nav-fill bg-light border-bottom">
              <li class="nav-item">
                <a class="nav-link py-3 fw-bold" :class="{ active: activeTab === 'read', 'text-success': activeTab === 'read' }" href="#" @click.prevent="activeTab = 'read'">
                  <i class="fas fa-check-circle ms-1"></i> تم الاطلاع ({{ selectedItem.readers.length }})
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link py-3 fw-bold" :class="{ active: activeTab === 'unread', 'text-danger': activeTab === 'unread' }" href="#" @click.prevent="activeTab = 'unread'">
                  <i class="fas fa-times-circle ms-1"></i> لم يتم الاطلاع ({{ selectedItem.non_readers.length }})
                </a>
              </li>
            </ul>

            <!-- المحتوى -->
            <div class="p-3">
              
              <!-- قائمة من قرأ -->
              <div v-if="activeTab === 'read'">
                <div class="input-group mb-3">
                  <span class="input-group-text bg-white border-end-0"><i class="fas fa-search text-muted"></i></span>
                  <input type="text" class="form-control border-start-0" placeholder="بحث في الأسماء..." v-model="searchQuery">
                </div>
                
                <div class="list-group list-group-flush border rounded overflow-hidden">
                  <div v-for="r in filteredReaders" :key="r.id" class="list-group-item d-flex justify-content-between align-items-center">
                    <div>
                      <span class="fw-bold d-block">{{ r.name }}</span>
                      <small class="text-muted">لجنة رقم: <span class="fw-bold text-dark">{{ r.committee_id }}</span></small>
                    </div>
                    <span class="badge bg-success-subtle text-success border border-success-subtle">
                      <i class="far fa-clock ms-1"></i> {{ formatTime(r.read_at) }}
                    </span>
                  </div>
                  <div v-if="filteredReaders.length === 0" class="text-center py-4 text-muted">لا توجد نتائج</div>
                </div>
              </div>

              <!-- قائمة من لم يقرأ -->
              <div v-if="activeTab === 'unread'">
                <div class="alert alert-danger d-flex align-items-center mb-3" v-if="selectedItem.non_readers.length > 0">
                  <i class="fas fa-exclamation-triangle fa-lg me-3 ms-2"></i>
                  <div>يمكنك التواصل مع هؤلاء الرؤساء لتنبيههم بضرورة فتح النظام.</div>
                </div>

                <div class="list-group list-group-flush border rounded overflow-hidden">
                  <div v-for="u in selectedItem.non_readers" :key="u.id" class="list-group-item d-flex justify-content-between align-items-center list-group-item-danger-subtle">
                    <div>
                      <span class="fw-bold text-danger d-block">{{ u.name }}</span>
                      <small class="text-danger-emphasis">لجنة رقم: <strong>{{ u.committee_id }}</strong></small>
                    </div>
                    <button class="btn btn-sm btn-outline-danger" title="إرسال تذكير (مستقبلاً)">
                      <i class="fas fa-bell"></i>
                    </button>
                  </div>
                  <div v-if="selectedItem.non_readers.length === 0" class="text-center py-5">
                    <i class="fas fa-check-double fa-3x text-success mb-3 opacity-50"></i>
                    <h5 class="fw-bold text-success">ممتاز! الجميع التزم بالتعليمات.</h5>
                  </div>
                </div>
              </div>

            </div>
          </div>
          
          <div class="modal-footer bg-light border-top-0">
            <button type="button" class="btn btn-secondary px-4" @click="closeModal">إغلاق</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "AdminSentInstructions",
  data() {
    return {
      instructions: {},
      showModal: false,
      activeTab: 'read',
      selectedItem: null,
      searchQuery: ''
    };
  },
  computed: {
    // فلتر البحث السريع داخل المودال
    filteredReaders() {
      if (!this.selectedItem) return [];
      if (!this.searchQuery) return this.selectedItem.readers;
      
      const query = this.searchQuery.toLowerCase();
      return this.selectedItem.readers.filter(r => 
        r.name.toLowerCase().includes(query) || 
        String(r.committee_id).includes(query)
      );
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh() {
      try {
        const res = await api.get('/admin/instructions-history');
        this.instructions = res.data;
      } catch (e) {
        console.error(e);
      }
    },

    async openDetails(id) {
      this.selectedItem = null;
      this.showModal = true;
      this.activeTab = 'read';
      this.searchQuery = '';
      
      try {
        const res = await api.get(`/admin/instructions-history/${id}`);
        this.selectedItem = res.data;
      } catch (e) {
        alert("فشل جلب التفاصيل");
        this.showModal = false;
      }
    },

    closeModal() {
      this.showModal = false;
    },

    calculatePercent(read, total) {
      if(total === 0) return 0;
      return Math.round((read / total) * 100);
    },
    
    getProgressColor(read, total) {
      const pct = this.calculatePercent(read, total);
      if(pct === 100) return 'bg-success';
      if(pct > 50) return 'bg-info';
      return 'bg-warning';
    },
    
    getProgressTextColor(read, total) {
      const pct = this.calculatePercent(read, total);
      if(pct === 100) return 'text-success';
      if(pct > 50) return 'text-info';
      return 'text-warning';
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString('ar-EG');
    },
    formatTime(date) {
      return new Date(date).toLocaleString('ar-EG', { hour: '2-digit', minute:'2-digit' });
    }
  }
};
</script>

<style scoped>
/* تحسين الكروت */
.instruction-card {
  transition: transform 0.2s, box-shadow 0.2s;
}
.instruction-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
}

/* تنسيق النصوص */
.text-truncate-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.xx-small { font-size: 0.7rem; }

/* تأثير الزر */
.btn-hover-effect:hover {
  background-color: #e9ecef;
}

/* خلفية المودال */
.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(2px);
}

/* تحسين القوائم داخل المودال */
.list-group-item-danger-subtle {
    background-color: #fff5f5;
}
</style>